import React from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from 'hedron';
import ProductCell from '../ProductCell';

const styles = {
  alignSelf: 'stretch'
  // borderBottom: '1px solid #cccccc',
  // borderRight: '1px solid #cccccc',
};

const ProductRow = ({
  currencySymbol,
  productRow,
  s3BasePath,
  isDesktop,
  showSale = false,
  lazyLoad,
  placeholderWidth,
  placeholderHeight
}) => (
  <Row>
    {productRow.map(product => (
      <Column key={`product-row-${product.product_id}`} fluid={isDesktop} xs={6} sm={3} md={3} lg={4} style={styles}>
        <ProductCell
          currencySymbol={currencySymbol}
          s3BasePath={s3BasePath}
          product={product}
          isDesktop={isDesktop}
          showSale={showSale}
          lazyLoad={lazyLoad}
          placeholderWidth={placeholderWidth}
          placeholderHeight={placeholderHeight}
        />
      </Column>
    ))}
  </Row>
);

ProductRow.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool,
  productRow: PropTypes.array.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  showSale: PropTypes.bool,
  lazyLoad: PropTypes.bool,
  placeholderWidth: PropTypes.bool,
  placeholderHeight: PropTypes.bool
};

export default ProductRow;
